import PropTypes from 'prop-types'
import { Modal, ModalBody } from 'components/modal'
import { InfoButton } from 'components/buttons'
import css from './deferred-payment-message.scss'

const LearnMoreWrapperModal = ({ className, onHide, show, children }) => (
  <Modal className={className} show={show} onHide={onHide} title=" ">
    <ModalBody className={css.learnMoreModalBody}>
      {children}
      <InfoButton className={css.gotItButton} onClick={onHide} pill block>
        Got It
      </InfoButton>
    </ModalBody>
  </Modal>
)

LearnMoreWrapperModal.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}

LearnMoreWrapperModal.defaultProps = {
  className: '',
}

export default LearnMoreWrapperModal
